import React from 'react';
import { FormikProps } from 'formik';
import { Modal } from '../../../components';
import { IProductInitialValuesProps } from '../types';

interface SubmitErrorModalProps {
  props: FormikProps<IProductInitialValuesProps>;
  showSubmitErrorModal: boolean;
  setShowSubmitErrorModal: (show: boolean) => void;
}

export const SubmitErrorModal: React.FC<SubmitErrorModalProps> = ({
  showSubmitErrorModal,
  setShowSubmitErrorModal,
}) => {
  return (
    <Modal
      open={showSubmitErrorModal}
      onClose={() => {
        setShowSubmitErrorModal(false);
      }}
      title="Update Product Failed"
      icon="error"
      footer={true}
      primaryAction={{
        label: 'OK',
        variant: 'primary',
        onClick: () => setShowSubmitErrorModal(false),
      }}
    >
      <div>
        <div className="mt-4">Your product was not saved. An error occurred whilst saving your product.</div>
      </div>
    </Modal>
  );
}; 